import { useState } from "react"
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  CardActionArea,
  CardActions,
  IconButton,
  Box,
  Modal,
  styled,
} from "@mui/material"
import { Carousel } from "react-responsive-carousel"
import CloseIcon from "@mui/icons-material/Close"

const style = {
  Modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%", // Set width to be responsive
    maxWidth: "600px", // Set a max width to limit size on large screens
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    maxHeight: "90vh", // Set the maximum height to be 90% of the viewport height
    overflowY: "auto", // Add a scrollbar if the content exceeds the height of the modal
    "@media (min-width:600px)": {
      width: "90%", // Adjust width for medium screens
    },
    "@media (min-width:1200px)": {
      width: "100%", // Adjust width for large screens
    },
  },

  CloseIcon: {
    cursor: "pointer",
    position: "absolute",
    top: 8,
    right: 8,
  },
}

// Estilos para la distribución del contenido dentro del modal
const ContainerModal = styled(Box)({
  display: "grid",
  gridTemplateColumns: "2fr 3fr", // Dos columnas: imagen e información
  gap: "16px",
  alignItems: "center",
  height: "100%", // Ajusta el contenedor al 100% de la altura del modal
})

const Imagen = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%", // Ocupa el 100% de la altura del contenedor
})

const Informacion = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  height: "100%", // Ocupa el 100% de la altura del contenedor
  overflowY: "auto", // Permite el scroll si el contenido es demasiado largo
})

const CustomModal = ({
  openModal,
  handleCloseModal,
  producto,
  inputCodigo,
  inputName,
  inputImage,
  inputPrecio,
  handleAgregar,
}) => {
  const codigoProducto = producto?.[inputCodigo] ?? ""
  const nombreProducto = producto?.[inputName] ?? ""
  const refImage = producto?.[inputImage] ?? [] //  array de imagenes
  const precioProducto = producto?.[inputPrecio] ?? "0.00"
  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style.Modal}>
        <ContainerModal>
          <Imagen>
            <Carousel>
              {refImage?.length > 0 ? (
                refImage.map((img, index) => (
                  <CardMedia
                    key={index} // Asigna un key único para cada imagen
                    component="img"
                    style={{ maxHeight: "100%", objectFit: "contain" }}
                    image={`data:image/jpeg;base64,${img}`} // Usa cada URL de imagen
                    alt="Imagen no disponible"
                  />
                ))
              ) : (
                <p>No existe imagen para este producto</p>
              )}
            </Carousel>
          </Imagen>
          <Informacion>
            <Typography variant="h4" component="h2" align="center" gutterBottom>
              Información del producto
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Código:</b> {codigoProducto}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Descripción:</b> {nombreProducto}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Marca:</b> {producto?.mardescri}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Medida:</b> {producto?.meddescri}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Presentación:</b> {producto?.predescri}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Linea:</b> {producto?.lindescri}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Iva:</b>
              {parseFloat(producto?.ivaProductoPorcentaje).toFixed(0)}%
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Precio:</b>${parseFloat(precioProducto ?? "0.00").toFixed(2)}
            </Typography>
          </Informacion>
          <Button variant="contained" color="primary" fullWidth onClick={() => handleAgregar(producto)} size="small">
            Agregar
          </Button>
        </ContainerModal>
      </Box>
    </Modal>
  )
}

const ProductCard = ({ handleAgregar, producto, inputCodigo, inputName, inputImage, inputPrecio }) => {
  const [openModal, setOpenModal] = useState(false)
  //  inputImage array de imagenes
  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)

  return (
    <>
      <Card
        sx={{
          maxWidth: 250,
          height: 300,
          padding: 1,
          borderRadius: 2,
          boxShadow: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardActionArea onClick={handleOpenModal} sx={{ flex: 1 }}>
          <CardMedia
            component="img"
            alt="Imagen no disponible"
            image={`data:image/jpeg;base64,${producto?.[inputImage]?.[0] ?? ""}`}
            sx={{ height: 80, objectFit: "contain", marginBottom: 1 }}
          />
          <CardContent sx={{ padding: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
              <Typography variant="subtitle2" fontWeight="bold">
                Código: {producto?.[inputCodigo] ?? ""}
              </Typography>
              <Typography variant="subtitle2" color="primary">
                ${parseFloat(producto?.[inputPrecio] ?? "0.00").toFixed(2)}
              </Typography>
            </Box>

            <Typography variant="caption" component="div">
              <strong>Descripción:</strong> {producto?.[inputName] ?? ""}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              <strong>Marca:</strong> {producto?.mardescri ?? ""} <br />
              <strong>Medida:</strong> {producto?.meddescri ?? ""} <br />
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            padding: "0.5rem",
          }}
        >
          <Button variant="contained" color="primary" fullWidth onClick={() => handleAgregar(producto)} size="small">
            Agregar
          </Button>
        </CardActions>
      </Card>

      <CustomModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        producto={producto}
        inputName={inputName}
        inputCodigo={inputCodigo}
        inputImage={inputImage}
        inputPrecio={inputPrecio}
        handleAgregar={handleAgregar}
      />
    </>
  )
}

export default ProductCard
